
































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Utils } from "@/core/Utils";
import ProfileSection from "./profileSection.vue";
import ProfileIndexComponent from "./profile.vue";
import ProfileTabContainer from "./profileTabContainer.vue";

@Component({
  name: "profile-child-component-viewer",
  components: { ProfileSection, ProfileIndexComponent, ProfileTabContainer }
})
export default class ProfileChildComponentViewer extends Vue {
  @Prop() public activeSection!: any;
  @Prop() public activeProfileInfo!: any[];
  @Prop() public cleanSearchCriteria!: any;

  activeChildSection: any = null;
  activeChildProfileInfo: any = null;


  get isMobile() {
    return this.$store.state.isMobile;
  }

  onSetActiveChild(childInfo:any) {
    this.activeChildSection = childInfo.section;
    this.activeChildProfileInfo = childInfo.profileInfo;
  }
  onChildGoBack() {
    this.activeChildSection = null;
  }
  goBack() {
      this.$emit("goBack");
  }
}
